export function salinity(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  return reading / scale
}
